import DataMapper from './../DataMapper'
import TreatingDoctorsData from '../../../models/CaseServiceData/TreatingDoctorsData'
import TreatingDoctorsDataRM from '../../responsemodel/CaseServiceDataRM/TreatingDoctorsDataRM'
class TreatingDoctorsDataMapper extends DataMapper<TreatingDoctorsDataRM, TreatingDoctorsData> {
    map = (rm: TreatingDoctorsDataRM) => new TreatingDoctorsData(rm.contactNumber, rm.doctorAvailableInHospital, rm.doctorConfirmation, rm.hospitalData, rm.investigatorName, rm.isFieldSaved, rm.personalMeeting, rm.personalMeetingPic, rm.qualification, rm.registrationCertificate, rm.registrationNumber, rm.treatingDoctorName)
}
export default TreatingDoctorsDataMapper
